"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.defaultJsonConfig = exports.ORGA_ICGC = exports.ORGA_SMC = exports.ORGA_TV3 = exports.TAGS_FILENAME_ICGC = exports.COLORS_FILENAME_ICGC = undefined;
exports.TAGS_FILENAME_SMC = exports.COLORS_FILENAME_SMC = exports.TAGS_FILENAME_TV3 = exports.COLORS_FILENAME_TV3 = exports.STRING_ERROR_CALCULS = exports.STRING_ERROR_CAMPS = exports.SELECT_TIPUS_FONT = exports.DO_UPDATEINDEXOS = exports.DO_UPDATEESTACIONS = exports.DO_DELETE = exports.CAMP_NOM_NEU = exports.CAMP_NOM_PLUJA = exports.DEFAULT_RANGS_VALORS_CHARTS = exports.RANGS_VALORS_CHARTS = exports.DEFAULT_NUMERIC_FIELDS = exports.DEFAULT_FIELDS = exports.DEFAULT_TITOL_GENERIC = exports.DEFAULT_GEOJSONPATH_URL = exports.SOURCE_MAIN = exports.WEATHER_ICONS_STYLES = exports.WEATHER_ICONS_TYPES = exports.DEFAULT_OPVISUAL = exports.DEFAULT_INDEX_SUFFIX_TEXT = exports.DEFAULT_INDEX_SUFFIX_POL = exports.DEFAULT_INDEX_LAYER_TEXT = exports.DEFAULT_INDEX_LAYER_POL = exports.BUTTONS_TYPE_TEXT = exports.BUTTONS_TYPE_ICONESTEXT = exports.BUTTONS_TYPE_ICONES = exports.BUTTONS_TYPE_BLANC = exports.PAS5_INFO_LIST_ULTIMVALUE = exports.PAS5_INFO_LIST = exports.OPT_CALCULS = exports.OPT_CALCULS_CALCVALUE = exports.OPT_CALCULS_SUM = exports.OPT_CALCULS_VALUE = exports.OPT_ULTIMAHORA = exports.OPT_HORES = exports.DEFAULT_SCALE = exports.LARGE_SCALE = exports.INIT_URL_TERRAIN = exports.INIT_URL_BACKGROUND = exports.INIT_BEARING = exports.INIT_PITCH = exports.MAX_ZOOM = exports.INIT_ZOOM = exports.INIT_LONG = exports.INIT_LAT = exports.MAX_WIDTH_SCREEN_SIZE_LEGEND = exports.MAPBOX_ACCESS_TOKEN = exports.CACHED_STATIONS_DATA = exports.CURRENT_STEP = exports.JSON_CONFIG_FILE = exports.SELECT_HORA25 = exports.SELECT_GRANULARITAT_HORES = exports.SELECT_GRANULARITAT_OPTIONS = exports.GRANULARITAT_HORES = exports.GRANULARITAT_DIES = exports.RANG_TEMPORAL_OPCIONS = exports.CUSTOM = exports.QUINZENA = exports.SETMANA = exports.LATEST = exports.TODAY = exports.SUFIX_STATIONS = exports.SUFIX_ACTUAL = exports.SUFIX_HISTORIC = exports.DB_FITXER_CSV = exports.DB_METEODADES = exports.DB_TEMPS_ACTUAL = exports.STEPS = exports.PAS5_PINTARDADES = exports.PAS4_TRACTAMENTDADES = exports.PAS3_SELECCIO_ESTACIONS = exports.PAS2_SELECCIO_CAMPS = exports.PAS1_SELECCIO_RANG = exports.PAS0_SELECCIO_BD = exports.DEFAULT_ICGC_BACKGROUNDS = exports.doLogin = exports.checkSession = exports.ADMIN_ROLE = exports.URL_SET_FILE_CONTENT = exports.URL_GET_FILE_CONTENT = exports.URL_UPDATEMEASURES = exports.URL_UPDATESTATIONS = exports.URL_RECREATE_INDEX = exports.URL_GET_LOCALDATA = exports.URL_DELETE_APPS = exports.URL_GET_CONFIG = exports.URL_GET_GEOJSON = exports.URL_VISOR_GEOJSON = exports.URL_GENERATE_GEOJSON = exports.URL_GET_STATIONS = exports.URL_GET_ICGC_MAPSTYLES = exports.URL_GET_COLUMNS = exports.URL_API_DB = exports.URL_UPLOAD_CSV = exports.URL_BASE_EDITOR = exports.URL_APP = exports.URL_SERVER = undefined;

var _dateFns = require("date-fns");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("moment/locale/ca");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//export const URL_SERVER = "https://meteotv3.icgc.cat/api/";  // "http://localhost:3001";
var URL_SERVER = exports.URL_SERVER = "http://localhost:3001";
//export const URL_SERVER = "http://nicosia.icgc.local:3001";
//export const URL_SERVER_FAKE = "http://localhost:3001";


//     

/* SERVER URL's */
//export const SERVER_LOCAL = "http://localhost:3001";
/* export const URL_SERVER = "http://highlands.icgc.local:3001";
export const URL_APP = "http://highlands.icgc.local:8080/#"; */

var URL_APP = exports.URL_APP = "http://localhost:8080/#";
var URL_BASE_EDITOR = exports.URL_BASE_EDITOR = URL_APP + "/editor";

var URL_UPLOAD_CSV = exports.URL_UPLOAD_CSV = URL_SERVER + "/api/upload/csv";
var URL_API_DB = exports.URL_API_DB = URL_SERVER + "/api/db"; // :idFile/columns
var URL_GET_COLUMNS = exports.URL_GET_COLUMNS = URL_SERVER + "/api/db"; // :idFile/columns
var URL_GET_ICGC_MAPSTYLES = exports.URL_GET_ICGC_MAPSTYLES = "https://tilemaps.icgc.cat/tileserver/styles/tv3-styles/config/config-tv3-styles.json";
var URL_GET_STATIONS = exports.URL_GET_STATIONS = URL_SERVER + "/api/db";
var URL_GENERATE_GEOJSON = exports.URL_GENERATE_GEOJSON = URL_SERVER + "/api/edit";
var URL_VISOR_GEOJSON = exports.URL_VISOR_GEOJSON = URL_SERVER + "/api/dynamic";
var URL_GET_GEOJSON = exports.URL_GET_GEOJSON = URL_SERVER + "/api/view";
var URL_GET_CONFIG = exports.URL_GET_CONFIG = URL_SERVER + "/api/config";
var URL_DELETE_APPS = exports.URL_DELETE_APPS = URL_SERVER + "/api/remove";
var URL_GET_LOCALDATA = exports.URL_GET_LOCALDATA = URL_SERVER + "/api/db/localdata";
var URL_RECREATE_INDEX = exports.URL_RECREATE_INDEX = URL_SERVER + "/api/db/createindex";
var URL_UPDATESTATIONS = exports.URL_UPDATESTATIONS = URL_SERVER + "/api/db/updatestationspoints";
var URL_UPDATEMEASURES = exports.URL_UPDATEMEASURES = URL_SERVER + "/api/db/updatemeasures/table/";
var URL_GET_FILE_CONTENT = exports.URL_GET_FILE_CONTENT = URL_SERVER + "/api/getFileContent";
var URL_SET_FILE_CONTENT = exports.URL_SET_FILE_CONTENT = URL_SERVER + "/api/setFileContent";

var ADMIN_ROLE = exports.ADMIN_ROLE = "admin";
var checkSession = exports.checkSession = URL_SERVER + "/api/auth/session";
var doLogin = exports.doLogin = URL_SERVER + "/api/auth/login";

var DEFAULT_ICGC_BACKGROUNDS = exports.DEFAULT_ICGC_BACKGROUNDS = {
	"backgrounds": [{
		"name": "Clar",
		"styleid": 0,
		"style": "https://geoserveis.icgc.cat/contextmaps/positron.json",
		"icon": "https://openicgc.github.io/img/positron.png"
	}, {
		"name": "Orto",
		"styleid": 1,
		"style": "https://geoserveis.icgc.cat/contextmaps/hibrid.json",
		"icon": "https://openicgc.github.io/img/orto.png"
	}, {
		"name": "Fosc",
		"styleid": 2,
		"style": "https://tilemaps.icgc.cat/tileserver/styles/tv3-styles/styles/fosc.json",
		"icon": "https://openicgc.github.io/img/fulldark.png"
	}, {
		"name": "Terreny",
		"styleid": 3,
		"style": "https://tilemaps.icgc.cat/tileserver/styles/terrain.json",
		"icon": "https://openicgc.github.io/img/terrain.png"
	}]
};

/* CONFIG PROCESS STEPS */
var PAS0_SELECCIO_BD = exports.PAS0_SELECCIO_BD = 0;
var PAS1_SELECCIO_RANG = exports.PAS1_SELECCIO_RANG = 1;
var PAS2_SELECCIO_CAMPS = exports.PAS2_SELECCIO_CAMPS = 2;
var PAS3_SELECCIO_ESTACIONS = exports.PAS3_SELECCIO_ESTACIONS = 3;
var PAS4_TRACTAMENTDADES = exports.PAS4_TRACTAMENTDADES = 4;
var PAS5_PINTARDADES = exports.PAS5_PINTARDADES = 5;

var STEPS = exports.STEPS = [{ key: 0, icon: "database", title: "1. Selecció de dades", description: "Selecciona la base de dades" }, { key: 1, icon: "calendar", title: "2. Selecció de dades", description: "Selecciona un rang temporal", link: false }, { key: 2, icon: "pin", title: "3. Selecció de dades", description: "Selecciona els camps" }, { key: 3, icon: "flag", title: "4. Selecció de dades", description: "Selecciona les estacions" }, { key: 4, icon: "calculator", title: "5. Tractament de dades", description: "Selecciona camps i càlculs" }, { key: 5, icon: "map", title: "6. Visualització de dades", description: "Configura el visor del mapa" }];

var DB_TEMPS_ACTUAL = exports.DB_TEMPS_ACTUAL = "tempsactual";
var DB_METEODADES = exports.DB_METEODADES = "meteodades";
var DB_FITXER_CSV = exports.DB_FITXER_CSV = "fitxercsv";
var SUFIX_HISTORIC = exports.SUFIX_HISTORIC = "_histo";
var SUFIX_ACTUAL = exports.SUFIX_ACTUAL = "_current";
var SUFIX_STATIONS = exports.SUFIX_STATIONS = "_stations";

var TODAY = exports.TODAY = "today";
var LATEST = exports.LATEST = "latest";
var SETMANA = exports.SETMANA = "setmana";
var QUINZENA = exports.QUINZENA = "quinzena";
var CUSTOM = exports.CUSTOM = "custom";

var RANG_TEMPORAL_OPCIONS = exports.RANG_TEMPORAL_OPCIONS = [{ key: 0, value: LATEST, text: "Últimes observacions", daystosubstractstartdate: 0, daystosubstractenddate: 0 }, { key: 1, value: TODAY, text: "Dia actual", daystosubstractstartdate: 0, daystosubstractenddate: 0 }, { key: 2, value: SETMANA, text: "Darrera setmana", daystosubstractstartdate: 8, daystosubstractenddate: 1 }, { key: 3, value: QUINZENA, text: "Darrera quinzena", daystosubstractstartdate: 15, daystosubstractenddate: 1 }, { key: 4, value: CUSTOM, text: "Defineix rang o dies", daystosubstractstartdate: 0, daystosubstractenddate: 0 }];

//hores (H)/dies (D)
var GRANULARITAT_DIES = exports.GRANULARITAT_DIES = "D";
var GRANULARITAT_HORES = exports.GRANULARITAT_HORES = "H";

var SELECT_GRANULARITAT_OPTIONS = exports.SELECT_GRANULARITAT_OPTIONS = [{ key: 0, value: "D", text: "Dies" }, { key: 1, value: "H", text: "Hores" }];

var SELECT_GRANULARITAT_HORES = exports.SELECT_GRANULARITAT_HORES = [{ key: 17, value: "17", text: "17h" }, { key: 18, value: "18", text: "18h" }, { key: 19, value: "19", text: "19h" }, { key: 20, value: "20", text: "20h" }, { key: 21, value: "21", text: "21h" }, { key: 22, value: "22", text: "22h" }, { key: 23, value: "23", text: "23h" }];

var SELECT_HORA25 = exports.SELECT_HORA25 = { key: 25, value: "25", text: "25h" };

var JSON_CONFIG_FILE = exports.JSON_CONFIG_FILE = "JSON_CONFIG_FILE";
var CURRENT_STEP = exports.CURRENT_STEP = "CURRENT_STEP";

var CACHED_STATIONS_DATA = exports.CACHED_STATIONS_DATA = "CACHED_STATIONS_DATA";

// export const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiZ2Vvc3RhcnRlcnMiLCJhIjoiMGNxekwxayJ9.sE1YC8Zxwzjh4CQeZiZN_g";
// export const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoidHYzaWNnYyIsImEiOiJjbDB3OWpvZnYxOHQ0M2puNWF5NHE5MjNhIn0.nYx7eR24LvfctdsuzzBVIQ"; //ja no funciona
var MAPBOX_ACCESS_TOKEN = exports.MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoibWFybmF0b24iLCJhIjoiY2w1aHU4Y3Q5MDFwdjNicGxtbWpnbTBqaiJ9.pCpoWYRxkmeCBJkQqhaF-Q";

var MAX_WIDTH_SCREEN_SIZE_LEGEND = exports.MAX_WIDTH_SCREEN_SIZE_LEGEND = 600;

//DEFAULT VIEW PARAMS
var INIT_LAT = exports.INIT_LAT = 41.70983;
var INIT_LONG = exports.INIT_LONG = 0.98877;
var INIT_ZOOM = exports.INIT_ZOOM = 8;
var MAX_ZOOM = exports.MAX_ZOOM = 13;
var INIT_PITCH = exports.INIT_PITCH = 45;
var INIT_BEARING = exports.INIT_BEARING = 0;

var INIT_URL_BACKGROUND = exports.INIT_URL_BACKGROUND = "https://tilemaps.icgc.cat/tileserver/styles/tv3-styles/styles/clar.json";
var INIT_URL_TERRAIN = exports.INIT_URL_TERRAIN = "https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png";

var LARGE_SCALE = exports.LARGE_SCALE = ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#ef6548", "#d7301f"];

var DEFAULT_SCALE = exports.DEFAULT_SCALE = ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59"];

var OPT_HORES = exports.OPT_HORES = [{ key: 1, value: "1", text: "1:00h" }, { key: 2, value: "2", text: "2:00h" }, { key: 3, value: "3", text: "3:00h" }, { key: 4, value: "4", text: "4:00h" }, { key: 5, value: "5", text: "5:00h" }, { key: 6, value: "6", text: "6:00h" }, { key: 7, value: "7", text: "7:00h" }, { key: 8, value: "8", text: "8:00h" }, { key: 9, value: "9", text: "9:00h" }, { key: 10, value: "10", text: "10:00h" }, { key: 11, value: "11", text: "11:00h" }, { key: 12, value: "12", text: "12:00h" }, { key: 13, value: "13", text: "13:00h" }, { key: 14, value: "14", text: "14:00h" }, { key: 15, value: "15", text: "15:00h" }, { key: 16, value: "16", text: "16:00h" }, { key: 17, value: "17", text: "17:00h" }, { key: 18, value: "18", text: "18:00h" }, { key: 19, value: "19", text: "19:00h" }, { key: 20, value: "20", text: "20:00h" }, { key: 21, value: "21", text: "21:00h" }, { key: 22, value: "22", text: "22:00h" }, { key: 23, value: "23", text: "23:00h" }];
var OPT_ULTIMAHORA = exports.OPT_ULTIMAHORA = { key: -1, value: "-1", text: "Última hora" };
//export const OPT_ULTIMAHORA_TXT = {key: 25, value: "25", text: "25h"};

var OPT_CALCULS_VALUE = exports.OPT_CALCULS_VALUE = "_value";
var OPT_CALCULS_SUM = exports.OPT_CALCULS_SUM = "_sum";
var OPT_CALCULS_CALCVALUE = exports.OPT_CALCULS_CALCVALUE = "_calcvalue";

var OPT_CALCULS = exports.OPT_CALCULS = [{ key: 0, text: "Últim valor", value: OPT_CALCULS_VALUE, color: "black" }, { key: 1, text: "Màxim", value: "_max", color: "#db2828" }, { key: 2, text: "Mínim", value: "_min", color: "#2185d0" }, { key: 3, text: "Mitjana", value: "_mean", color: "#a333c8" }, { key: 4, text: "Sumatori", value: OPT_CALCULS_SUM, color: "#f2711c" }, { key: 5, text: "Valor calculat", value: OPT_CALCULS_CALCVALUE, color: "#00b5ad" }];

var PAS5_INFO_LIST = exports.PAS5_INFO_LIST = ["Si es selecciona un únic camp la operació 'Diferència de valors / comparativa' estarà disponible", "Si es selecciona un únic camp es podrà definir el rang de valors en que s'aplicaran els càlculs"];

var PAS5_INFO_LIST_ULTIMVALUE = exports.PAS5_INFO_LIST_ULTIMVALUE = ["Si has seleccionat 'Últimes observacions' al pas 2, la única operació disponible és 'Últim valor'"];

var BUTTONS_TYPE_BLANC = exports.BUTTONS_TYPE_BLANC = "Blanc";
var BUTTONS_TYPE_ICONES = exports.BUTTONS_TYPE_ICONES = "Icones";
var BUTTONS_TYPE_ICONESTEXT = exports.BUTTONS_TYPE_ICONESTEXT = "IconesText";
var BUTTONS_TYPE_TEXT = exports.BUTTONS_TYPE_TEXT = "Text";

var DEFAULT_INDEX_LAYER_POL = exports.DEFAULT_INDEX_LAYER_POL = 0;
var DEFAULT_INDEX_LAYER_TEXT = exports.DEFAULT_INDEX_LAYER_TEXT = 1;

var DEFAULT_INDEX_SUFFIX_POL = exports.DEFAULT_INDEX_SUFFIX_POL = "_pol";
var DEFAULT_INDEX_SUFFIX_TEXT = exports.DEFAULT_INDEX_SUFFIX_TEXT = "_text";

var DEFAULT_OPVISUAL = exports.DEFAULT_OPVISUAL = "blanc";

var WEATHER_ICONS_TYPES = exports.WEATHER_ICONS_TYPES = ["thermometer", "humidity", "umbrella", "raindrop", "raindrops", "strong-wind", "wind-direction", "day-sunny", "rain", "snowflake-cold"];
var WEATHER_ICONS_STYLES = exports.WEATHER_ICONS_STYLES = ["negre", "vermell", "blau"];

var SOURCE_MAIN = exports.SOURCE_MAIN = "stations";

var DEFAULT_GEOJSONPATH_URL = exports.DEFAULT_GEOJSONPATH_URL = "2f9ac60f-69c5-4213-a8bb-3a395d812059.json";
//export const DEFAULT_GEOJSONPATH_URL = "http://localhost:3001/2f9ac60f-69c5-4213-a8bb-3a395d812059.json";

var DEFAULT_TITOL_GENERIC = exports.DEFAULT_TITOL_GENERIC = "Títol visor";

var DEFAULT_FIELDS = exports.DEFAULT_FIELDS = ["nomok", "comarca", "font", "data", "Alt"];
var DEFAULT_NUMERIC_FIELDS = exports.DEFAULT_NUMERIC_FIELDS = ["temp", "temp.max", "temp.min", "amplitud.termica", "ventfor", "ventmax", "windchill", "humitat", "humidex", "pluja", "patm", "alt"];

var RANGS_VALORS_CHARTS = exports.RANGS_VALORS_CHARTS = {
	"temperatura": { "min": -20, "max": 40, "unitat": "ºC", "color": "#097138", "chartType": "LineChart", "pattern": "d-MMM-yyyy,HH:mm" },
	"vent": { "min": 0, "max": 200, "unitat": "km/h", "color": "#3366CC", "chartType": "LineChart", "pattern": "d-MMM-yyyy,HH:mm" },
	"amplitud.termica": { "min": 0, "max": 40, "unitat": "ºC", "color": "#ff7606", "chartType": "LineChart", "pattern": "d-MMM-yyyy,HH:mm" },
	"pluja": { "min": 0, "max": 3000, "unitat": "mm", "color": "#3366CC", "chartType": "ColumnChart", "pattern": "d-MMM-yyyy,HH:mm UTC" },
	"humitat": { "min": 0, "max": 100, "unitat": "%", "color": "#3366CC", "chartType": "LineChart", "pattern": "d-MMM-yyyy,HH:mm" },
	"patm": { "min": 970, "max": 1050, "unitat": "hPa", "color": "#3366CC", "chartType": "LineChart", "pattern": "d-MMM-yyyy,HH:mm" },
	"neu": { "min": 0, "max": 100, "unitat": "mm", "color": "#7587aa", "chartType": "ColumnChart", "pattern": "d-MMM-yyyy,HH:mm UTC" },
	"pluja30": { "min": 0, "max": 250, "unitat": "mm", "color": "#3366CC", "chartType": "ColumnChart", "pattern": "d-MMM-yyyy,HH:mm UTC" },
	"neu30": { "min": 0, "max": 250, "unitat": "mm", "color": "#7587aa", "chartType": "ColumnChart", "pattern": "d-MMM-yyyy,HH:mm UTC" },
	"pluja365": { "min": 0, "max": 3000, "unitat": "mm", "color": "#3366CC", "chartType": "ColumnChart", "pattern": "d-MMM-yyyy,HH:mm UTC" },
	"neu365": { "min": 0, "max": 1200, "unitat": "mm", "color": "#7587aa", "chartType": "ColumnChart", "pattern": "d-MMM-yyyy,HH:mm UTC" },
	"alt": { "min": 0, "max": 4000, "unitat": "m", "color": "#7587aa", "chartType": "GeoChart", "pattern": "d-MMM-yyyy,HH:mm UTC" }
};

var DEFAULT_RANGS_VALORS_CHARTS = exports.DEFAULT_RANGS_VALORS_CHARTS = { "min": -20, "max": 40, "unitat": "ºC", "color": "#097138", "chartType": "LineChart" };

var CAMP_NOM_PLUJA = exports.CAMP_NOM_PLUJA = "pluja";
var CAMP_NOM_NEU = exports.CAMP_NOM_NEU = "neu";

var DO_DELETE = exports.DO_DELETE = "delete";
var DO_UPDATEESTACIONS = exports.DO_UPDATEESTACIONS = "updateestacions";
var DO_UPDATEINDEXOS = exports.DO_UPDATEINDEXOS = "updateindexos";

var SELECT_TIPUS_FONT = exports.SELECT_TIPUS_FONT = [{ key: 0, value: "Lato-Reg", text: "Lato-Reg", className: "latofont" }, { key: 1, value: "Crimson-Semibold", text: "Crimson-Semibold", className: "crimsonfont" }, { key: 2, value: "Merriweather-Black", text: "Merriweather-Black", className: "merryweatherboldfont" }, { key: 3, value: "Merriweather-Regular", text: "Merriweather-Regular", className: "merryweatherfont" }, { key: 4, value: "Noto Sans Bold", text: "Noto Sans Bold", className: "notoboldfont" }, { key: 5, value: "Noto Sans Regular", text: "Noto Sans Regular", className: "notofont" }, { key: 6, value: "Open Sans Bold", text: "Open Sans Bold", className: "opensansboldfont" }, { key: 7, value: "Open Sans Regular", text: "Open Sans Regular", className: "opensansfont" }, { key: 8, value: "Roboto-Bold", text: "Roboto-Bold", className: "robotoboldfont" }, { key: 9, value: "Roboto-Regular", text: "Roboto-Regular", className: "robotofont" }];

/* ERROR MESSAGES */
var STRING_ERROR_CAMPS = exports.STRING_ERROR_CAMPS = "Si us plau, selecciona com a mínim un camp per continuar";
var STRING_ERROR_CALCULS = exports.STRING_ERROR_CALCULS = "Si us plau, selecciona com a mínim un càlcul a realitzar";

var COLORS_FILENAME_TV3 = exports.COLORS_FILENAME_TV3 = "colors_tv3.json";
var TAGS_FILENAME_TV3 = exports.TAGS_FILENAME_TV3 = "tags_tv3.json";

var COLORS_FILENAME_SMC = exports.COLORS_FILENAME_SMC = "colors_smc.json";
var TAGS_FILENAME_SMC = exports.TAGS_FILENAME_SMC = "tags_smc.json";

var COLORS_FILENAME_ICGC = exports.COLORS_FILENAME_ICGC = "colors_icgc.json";
var TAGS_FILENAME_ICGC = exports.TAGS_FILENAME_ICGC = "tags_icgc.json";

var ORGA_TV3 = exports.ORGA_TV3 = "tv3";
var ORGA_SMC = exports.ORGA_SMC = "smc";
var ORGA_ICGC = exports.ORGA_ICGC = "icgc";

var defaultJsonConfig = exports.defaultJsonConfig = {

	"data": {
		"databasename": DB_TEMPS_ACTUAL,
		"isCSVFile": false

	},

	"apps": {
		"visor": "",
		"editor": ""
	},

	"organization": ORGA_TV3,

	"timerange": {
		"tipus": "",
		"timemax": (0, _dateFns.format)((0, _dateFns.subDays)(new Date(), 1), "yyyy-MM-dd"),
		"timemin": (0, _dateFns.format)((0, _dateFns.subDays)(new Date(), 2), "yyyy-MM-dd"),
		"timestamps": [],
		"timestampscalcvalue": [],
		"dynamic": false,
		"singledays": false
	},

	"selectedfields": DEFAULT_FIELDS,

	"selectedorganizations": [],

	"selectedfieldsLabels": {
		"temp": "Temperatura ºC",
		"temp.max": "Temperatura Màx. ºC",
		"temp.min": "Temperatura Min. ºC",
		"amplitud.termica": "Amplitud térmica ºC",
		"ventfor": "Vent Km/h",
		"ventmax": "Vent Màx. Km/h",
		"windchill": "Sensació Tèrmica ºC",
		"humitat": "Humitat %",
		"humidex": "Humidex ºC",
		"pluja": "Pluja mm",
		"patm": "Pressió Atmosfèrica hPa",
		"nomok": "Nom",
		"comarca": "Comarca",
		"webcams": "Webcamp",
		"font": "Font",
		"created_at_time": "Data",
		"poblacio": "Població",
		"alt": "Altitud"
	},

	"tooltipfields": ["nomok", "comarca", "webcams", "temp_value", "temp.max_value", "temp.min_value", "amplitud.termica_value", "windchill_value", "humitat_value", "humidex_value", "pluja_value", "ventdir_value", "ventfor_value", "ventmax_value", "font", "alt", "created_at_time"],
	"selectedstationsids": [],
	"iscat": false,

	"calcdatafieldsOptions": {
		"sincronitazio": false,
		"dbextra": DB_FITXER_CSV,
		"dbextraprimaria": false,
		"dbextraany": 2013,
		"granularitat": GRANULARITAT_HORES,
		"hora": "25",
		//params filtres calcvalue
		"rang": { "min": 0, "max": 50 },
		"horafiltremin": "1",
		"horafiltremax": "1"
	},

	"calcdatafieldsCalculs": {
		"_value": true,
		"_min": false,
		"_max": false,
		"_sum": false,
		"_mean": false,
		"_calcvalue": false
	},

	"calcdatafields": [],

	"vieweroptions": {

		"geojsonpath": "", //DEFAULT_GEOJSONPATH_URL,
		"style": { "id": 2, "url": INIT_URL_BACKGROUND },
		"isEditor": true,
		"sourcename": DB_TEMPS_ACTUAL,
		"isNewVisor": true,
		"publicat": false,
		"initview": {
			"lat": INIT_LAT,
			"lon": INIT_LONG,
			"zoom": INIT_ZOOM,
			"pitch": INIT_PITCH,
			"bearing": INIT_BEARING
		},

		"infowindow": {
			"title": "temperatures",
			"viewpopup": true,
			"viewtitlebar": false,
			"viewinfopanel": true,
			"viewlegend": false,
			"viewfilter": false,
			"viewcercador": false,
			"viewfiltersources": [],
			"fields": ["temp_value", "comarca"],
			"colorPanell": { "r": "251", "g": "251", "b": "251", "a": "1" },
			"colorPanellText": { "r": "51", "g": "51", "b": "51", "a": "1" }
		},
		"units": "metric",
		"animationfields": {
			"x": "created_at",
			"y": "temp",
			"timemax": "2018-03-23 08:53:00h",
			"timemin": "2018-03-23 08:23:00h"
		},
		"thematicoptions": [],
		"heatmaplayer": false,
		"layoutoptions": {
			"title": DEFAULT_TITOL_GENERIC,
			"legend": false,
			"windowinfo": false,
			"opvisual": DEFAULT_OPVISUAL,
			"twitter": false,
			"tags": [],
			"hashtags": "EltempsTV3",
			"users": "@eltempsTV3",
			"facebook": false,
			"urltwitter": "https://twitter.com/intent/tweet?",
			"urlfacebook": "https://facebook.com/sharer/sharer.php?u="

		}

	}
};
